module.exports = __webpack_public_path__ + "static/media/RIESGOS_FISICOS.0ab5f3de.jpg";